module.exports = __webpack_public_path__ + "img/message2.2283f346.png";